export default "__VITE_ASSET__0ae2bb0c__"